import React from 'react';

const Switzerland = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" fill="#F93939" />
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <path fillRule="evenodd" clipRule="evenodd" d="M12 8H8V12H12V16H16V12H20V8H16V4H12V8Z" fill="white" />
  </svg>
);

export default Switzerland;
